<template>
  <layout>
    <div class="text-white pb-20">
      <div class="relative">
        <div class="relative spaceforce-hero">
          <ResponsiveImage :image="data.intro_image" />
          <div class="absolute h-40 bottom-0 left-0 w-full bg-gradient-to-b from-transparent to-black" />
          <div class="absolute bottom-0 right-0 p-8">
            <svg
              width="62"
              height="80"
              viewBox="0 0 62 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.4375 56.5009L26.9603 46.0194L44.4831 56.5009L26.9603 3.99512L9.4375 56.5009Z"
                fill="black" />
              <path
                d="M26.96 3.99486L44.4828 56.5006L26.96 46.0191L9.43718 56.5006L26.96 3.99486ZM26.96 0L7.16016 59.3368L26.9644 47.4909L46.7687 59.3368L26.96 0Z"
                fill="url(#paint0_linear_7153_81736)" />
              <path
                d="M28.0195 13.1787L41.0598 52.3668L28.0195 44.5426L32.3723 41.9435L28.0195 13.1787Z"
                fill="url(#paint1_linear_7153_81736)" />
              <path
                d="M25.9042 13.1787L12.8594 52.3668L25.9042 44.5426L21.5514 41.9435L25.9042 13.1787Z"
                fill="url(#paint2_linear_7153_81736)" />
              <path
                d="M41.0598 52.3667L28.0195 44.5425L32.3723 41.9434L41.0598 52.3667Z"
                fill="url(#paint3_linear_7153_81736)" />
              <path
                d="M12.8594 52.3667L25.9042 44.5425L21.5514 41.9434L12.8594 52.3667Z"
                fill="url(#paint4_linear_7153_81736)" />
              <path
                d="M26.116 37.368L23.168 38.2179L26.116 39.0634L26.9615 42.0115L27.8115 39.0634L30.7595 38.2179L27.8115 37.368L26.9615 34.4199L26.116 37.368Z"
                fill="url(#paint5_radial_7153_81736)" />
              <path
                d="M23.01 72.6326H17.5881C16.9395 72.6326 16.4071 72.1674 16.4071 71.5187C16.4071 70.87 17.0111 70.3153 17.6597 70.3153H25.2065L26.4189 67.998H17.6597C15.7137 67.998 14.0898 69.5727 14.0898 71.5187C14.0898 73.4647 15.7137 74.9499 17.6597 74.9499H23.0816C23.7303 74.9499 24.2626 75.4151 24.2626 76.0638C24.2626 76.7125 23.6587 77.2672 23.01 77.2672H15.4632L14.2509 79.5845H23.01C24.956 79.5845 26.5799 78.0098 26.5799 76.0638C26.5799 74.1178 24.956 72.6326 23.01 72.6326Z"
                fill="white" />
              <path
                d="M37.5569 72.6326H32.135C31.4864 72.6326 30.954 72.1674 30.954 71.5187C30.954 70.87 31.5579 70.3153 32.2066 70.3153H39.7534L40.9657 67.998H32.2066C30.2606 67.998 28.6367 69.5727 28.6367 71.5187C28.6367 73.4647 30.2606 74.9499 32.2066 74.9499H37.6285C38.2772 74.9499 38.8095 75.4151 38.8095 76.0638C38.8095 76.7125 38.2056 77.2672 37.5569 77.2672H30.0101L28.7978 79.5845H37.5569C39.5029 79.5845 41.1268 78.0098 41.1268 76.0638C41.1268 74.1178 39.5029 72.6326 37.5569 72.6326Z"
                fill="white" />
              <path
                d="M9.29151 73.8673C9.29151 76.2427 8.07023 77.719 5.78874 77.719C3.50724 77.719 2.30834 76.2159 2.30834 73.8405V67.998H0V74.006C0 77.6161 2.13387 80.0005 5.81558 80.0005C9.49729 80.0005 11.6043 77.5938 11.6043 74.0284V67.998H9.29151V73.8673Z"
                fill="white" />
              <path
                d="M56.4186 70.3241L55.1839 68.0068H44.2148V79.884H46.5321V74.9587H52.7459L53.8508 72.6369H46.5321V70.3241H56.4186Z"
                fill="white" />
              <path
                d="M61.0134 69.2863C61.0134 68.9732 60.7629 68.7227 60.4498 68.7227H59.6445V70.6284H60.0024V69.8545H60.2574L60.6198 70.6284H61.0134L60.6376 69.8231C60.8568 69.7471 61.0134 69.5324 61.0134 69.2908V69.2863ZM60.4498 69.4966H60.0024V69.0805H60.4498C60.5661 69.0805 60.6555 69.1745 60.6555 69.2863C60.6555 69.3982 60.5616 69.4966 60.4498 69.4966Z"
                fill="white" />
              <path
                d="M60.3288 68.0068C59.4072 68.0068 58.6602 68.7539 58.6602 69.6755C58.6602 70.597 59.4072 71.3441 60.3288 71.3441C61.2503 71.3441 61.9974 70.597 61.9974 69.6755C61.9974 68.7539 61.2503 68.0068 60.3288 68.0068ZM60.3288 70.9862C59.6041 70.9862 59.018 70.4002 59.018 69.6755C59.018 68.9507 59.6041 68.3647 60.3288 68.3647C61.0535 68.3647 61.6395 68.9507 61.6395 69.6755C61.6395 70.4002 61.0535 70.9862 60.3288 70.9862Z"
                fill="white" />
              <defs>
                <linearGradient
                  id="paint0_linear_7153_81736"
                  x1="26.96"
                  y1="59.3413"
                  x2="26.96"
                  y2="0"
                  gradientUnits="userSpaceOnUse">
                  <stop
                    offset="0.11"
                    stop-color="#95A3AE" />
                  <stop
                    offset="0.16"
                    stop-color="#A2AFB9" />
                  <stop
                    offset="0.26"
                    stop-color="#BBC5CE" />
                  <stop
                    offset="0.36"
                    stop-color="#CDD4DD" />
                  <stop
                    offset="0.48"
                    stop-color="#D7DEE6" />
                  <stop
                    offset="0.61"
                    stop-color="#DBE1E9" />
                  <stop
                    offset="1"
                    stop-color="#95A3AE" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_7153_81736"
                  x1="34.5419"
                  y1="13.1787"
                  x2="34.5419"
                  y2="52.3668"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#8791A1" />
                  <stop
                    offset="0.12"
                    stop-color="#98A1B0" />
                  <stop
                    offset="0.34"
                    stop-color="#B5BCC9" />
                  <stop
                    offset="0.57"
                    stop-color="#CAD0DA" />
                  <stop
                    offset="0.79"
                    stop-color="#D6DCE5" />
                  <stop
                    offset="1"
                    stop-color="#DBE0E9" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_7153_81736"
                  x1="19.3818"
                  y1="13.1787"
                  x2="19.3818"
                  y2="52.3668"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#8791A1" />
                  <stop
                    offset="0.12"
                    stop-color="#98A1B0" />
                  <stop
                    offset="0.34"
                    stop-color="#B5BCC9" />
                  <stop
                    offset="0.57"
                    stop-color="#CAD0DA" />
                  <stop
                    offset="0.79"
                    stop-color="#D6DCE5" />
                  <stop
                    offset="1"
                    stop-color="#DBE0E9" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_7153_81736"
                  x1="36.5774"
                  y1="46.6182"
                  x2="32.8823"
                  y2="49.942"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#44515D" />
                  <stop
                    offset="0.07"
                    stop-color="#54606B" />
                  <stop
                    offset="0.29"
                    stop-color="#838D98" />
                  <stop
                    offset="0.5"
                    stop-color="#A9B1BB" />
                  <stop
                    offset="0.7"
                    stop-color="#C4CBD4" />
                  <stop
                    offset="0.87"
                    stop-color="#D5DBE3" />
                  <stop
                    offset="1"
                    stop-color="#DBE1E9" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_7153_81736"
                  x1="17.3463"
                  y1="46.6182"
                  x2="21.0414"
                  y2="49.942"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#44515D" />
                  <stop
                    offset="0.07"
                    stop-color="#54606B" />
                  <stop
                    offset="0.29"
                    stop-color="#838D98" />
                  <stop
                    offset="0.5"
                    stop-color="#A9B1BB" />
                  <stop
                    offset="0.7"
                    stop-color="#C4CBD4" />
                  <stop
                    offset="0.87"
                    stop-color="#D5DBE3" />
                  <stop
                    offset="1"
                    stop-color="#DBE1E9" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_7153_81736"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(25.5142 37.9413) rotate(180) scale(3.78907)">
                  <stop
                    offset="0.4"
                    stop-color="#DBE1E9" />
                  <stop
                    offset="0.52"
                    stop-color="#D6DCE4" />
                  <stop
                    offset="0.66"
                    stop-color="#C7CED8" />
                  <stop
                    offset="0.81"
                    stop-color="#AFB8C3" />
                  <stop
                    offset="0.97"
                    stop-color="#8E98A7" />
                  <stop
                    offset="1"
                    stop-color="#8892A1" />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>
        <div class="absolute py-8 md:py-20 top-0 w-full">
          <div class="flex items-center justify-center w-full">
            <div>
              <svg
                class="w-64 md:w-96"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 156.74043 27.52475">
                <path
                  fill="white"
                  d="M0,24.90882l1.88794-1.4752c.84612,1.35707,1.98685,2.08506,3.44284,2.08506,1.59261,0,2.596-1.02331,2.596-2.30139,0-1.4752-1.57411-1.94771-3.22579-2.47859-1.94771-.62908-4.05199-1.41613-4.05199-4.05199,0-2.18326,1.94771-3.91393,4.60278-3.91393,2.18326,0,3.54033,.84541,4.64192,2.1242l-1.75059,1.298c-.649-1.00339-1.61254-1.53426-2.89133-1.53426-1.45527,0-2.40031,.86533-2.40031,1.98685,0,1.37699,1.51505,1.82887,3.16744,2.37967,1.96693,.66893,4.11105,1.51505,4.11105,4.19004,0,2.20319-1.80966,4.30746-4.77998,4.30746-2.45866,0-4.13098-1.04253-5.34999-2.61593ZM14.50346,12.9692h4.72091c3.0486,0,5.19201,2.20319,5.19201,5.03545,0,2.81305-2.14341,5.03545-5.21193,5.03545h-2.55758v4.28824l-2.14341-1.45741V12.9692Zm2.14341,1.96693v6.11712h2.41952c1.96693,0,3.20658-1.33714,3.20658-3.0486,0-1.73067-1.23965-3.06852-3.20658-3.06852h-2.41952Zm14.38192-1.96693h2.20319l5.27171,14.35914h-2.22311l-1.12081-3.06852h-6.05805l-1.10159,3.06852h-2.24233l5.271-14.35914Zm-1.17987,9.2447h4.56293l-2.28147-6.29431-2.28147,6.29431Zm10.28738-2.06513c0-4.19004,3.26564-7.37598,7.37669-7.37598,2.71413,0,5.07459,1.45527,6.35338,3.61932l-1.86872,1.15995c-.88526-1.65168-2.45937-2.71413-4.48465-2.71413-2.99024,0-5.23186,2.36046-5.23186,5.31085,0,2.91125,2.24161,5.27171,5.21193,5.27171,2.22311,0,3.81573-1.21972,4.64192-2.95039l1.92779,1.0226c-1.23965,2.3996-3.61932,4.03206-6.54978,4.03206-4.24839,0-7.37669-3.30407-7.37669-7.37598Zm17.70662-7.17957h8.61492l-1.45741,2.02599h-5.0141v4.11105h6.47151l-1.45741,2.02599h-5.0141v4.15019h6.47151l-1.45741,2.04592h-7.15751V12.9692Zm20.06921,0h8.61452l-1.45741,2.02599h-5.0137v4.11105h6.47111l-1.45741,2.02599h-5.0137v6.19611l-2.14341-1.45741V12.9692Zm11.03667,7.17957c0-4.07191,3.28486-7.37598,7.35677-7.37598,4.09112,0,7.37527,3.30407,7.37527,7.37598s-3.28414,7.37598-7.37527,7.37598c-4.07191,0-7.35677-3.30407-7.35677-7.37598Zm12.58862,0c0-2.91125-2.28147-5.31085-5.23186-5.31085-2.93118,0-5.21336,2.3996-5.21336,5.31085s2.28218,5.29092,5.21336,5.29092c2.95039,0,5.23186-2.37967,5.23186-5.29092Zm5.90505-7.17957h4.46544c3.0486,0,5.07459,2.06513,5.07459,4.68177,0,1.90786-1.06174,3.71752-3.10766,4.3466l3.4222,5.33077h-2.45795l-4.3281-6.84511h1.16066c2.14412,0,3.16744-1.51505,3.16744-2.83226,0-1.61325-1.04324-2.69492-3.14822-2.69492h-2.10427v12.37229l-2.14412-1.45741V12.9692Zm12.89838,7.17957c0-4.19004,3.26493-7.37598,7.37527-7.37598,2.71484,0,5.0753,1.45527,6.35338,3.61932l-1.86872,1.15995c-.88455-1.65168-2.45795-2.71413-4.48465-2.71413-2.98882,0-5.23186,2.36046-5.23186,5.31085,0,2.91125,2.24304,5.27171,5.21264,5.27171,2.2224,0,3.81644-1.21972,4.64192-2.95039l1.92779,1.0226c-1.23894,2.3996-3.61932,4.03206-6.5505,4.03206-4.24839,0-7.37527-3.30407-7.37527-7.37598Zm17.82856-7.17957h8.61563l-1.45741,2.02599h-5.0141v4.11105h6.47151l-1.45741,2.02599h-5.0141v4.15019h6.47151l-1.45741,2.04592h-7.15822V12.9692ZM28.27887,2.69702V.24527h-1.0093V2.69702c0,.95237-.49008,1.54647-1.40478,1.54647-.90528,0-1.39582-.60352-1.39582-1.55589V.23585h-1.00886V2.68761c0,1.49939,.88645,2.48942,2.41409,2.48942,1.50881,0,2.40467-.99945,2.40467-2.48001Zm9.74102,2.62169V.23585h-.99945V2.98937c0,.07533,.00942,.31118,.00942,.31118l-3.88524-3.30055V5.11112h1.00931V2.41409c0-.08474-.00942-.38651-.00942-.38651l3.87537,3.29113Zm6.03144-.2076V.23585h-1.00931V5.11112h1.00931Zm8.85656-3.96057V.23585h-4.56454l.00942,.9147h1.78232v3.96057h.99048V1.15055h1.78232Zm7.24301,1.95181v-.86762h-2.0935V1.15055h2.69736V.23585h-3.6968V5.11112h3.70622v-.9147h-2.70678v-1.09405h2.0935Zm6.94113,2.00875h-1.93343V.23585h1.93343c1.48056,0,2.63066,1.09361,2.63066,2.44234,0,1.32945-1.1501,2.43292-2.63066,2.43292Zm-.03811-3.9794h-.89542v3.0647h.89542c.92457,0,1.66933-.67885,1.66933-1.52764s-.74476-1.53706-1.66933-1.53706Zm24.45559,.01883V.23585h-4.56409l.00942,.9147h1.78232v3.96057h.99048V1.15055h1.78187Zm15.9175,0V.23585h-4.56454l.00942,.9147h1.78232v3.96057h.99048V1.15055h1.78232Zm7.26141,1.95181v-.86762h-2.0935V1.15055h2.69736V.23585h-3.6968V5.11112h3.70622v-.9147h-2.70678v-1.09405h2.0935ZM97.33597,.15909l-2.50739,4.95202h1.03174l.45568-.92341h2.03994l.45568,.92341h1.03174L97.33597,.15909Zm-.6512,3.24404l.6512-1.30491,.6512,1.30491h-1.3024Zm-15.3094-1.16867c-.9258-.22152-1.09071-.37743-1.09071-.7048,0-.31026,.29072-.51874,.72347-.51874,.41736,0,.83066,.15716,1.26352,.48047l.04471,.03296,.51187-.72113-.03993-.03213c-.5126-.41169-1.0904-.612-1.76666-.612-.99152,0-1.6841,.59448-1.6841,1.44548,0,.91208,.59776,1.23534,1.63107,1.48535,.88608,.204,1.0355,.37582,1.0355,.68364,0,.34125-.3033,.55294-.79157,.55294-.53298,0-.98694-.18731-1.47189-.60748l-.04159-.03582-.57416,.6824,.0391,.03504c.5701,.50896,1.27121,.77769,2.02816,.77769,1.06887,0,1.75948-.58346,1.75948-1.4866,0-.76344-.45646-1.18569-1.57628-1.45728Zm40.37328,0c-.9258-.22152-1.09071-.37743-1.09071-.7048,0-.31026,.29072-.51874,.72347-.51874,.41736,0,.83066,.15716,1.26352,.48047l.04471,.03296,.51187-.72113-.03993-.03213c-.5126-.41169-1.0904-.612-1.76666-.612-.99152,0-1.6841,.59448-1.6841,1.44548,0,.91208,.59776,1.23534,1.63107,1.48535,.88608,.204,1.0355,.37582,1.0355,.68364,0,.34125-.3033,.55294-.79157,.55294-.53298,0-.98694-.18731-1.47189-.60748l-.04159-.03582-.57416,.6824,.0391,.03504c.5701,.50896,1.27121,.77769,2.02816,.77769,1.06887,0,1.75948-.58346,1.75948-1.4866,0-.76344-.45646-1.18569-1.57628-1.45728Z" /><g><path
                    d="M152.94523,13.43464h-.97742v2.60458h-.53901v-2.60458h-.97742v-.46544h2.49385v.46544Z"
                    fill="white" /><path
                      fill="white"
                      d="M156.74043,16.03922h-.51161l.0045-1.14783c0-.10135,0-.24436,.00488-.42865,0-.1843,.0045-.32731,.00901-.42415,.00488-.19368,.00938-.30892,.02778-.60845-.06456,.23948-.19368,.64073-.29503,.92637l-.60394,1.68271h-.43804l-.63585-1.65493c-.08783-.23985-.22146-.67301-.28602-.93125l.01389,.28114c.01839,.40576,.0229,.63622,.02778,1.11555l.0045,1.1895h-.51161v-3.07002h.75146l.59006,1.60426,.10135,.32243,.10135,.32731,.06456,.22596,.06456-.23047,.09196-.30441,.10623-.34082,.56678-1.60426h.75146v3.07002Z" /></g>
              </svg>
            </div>
          </div>
        </div>
        <div class="lg:absolute lg:bottom-0 h-1/3 w-full bg-gradient-to-t from-black opacity-75" />
        <div class="lg:absolute lg:bottom-0 lg:left-0 lg:right-0 container mx-auto z-10">
          <div class="grid sm:grid-cols-2 gap-4 max-w-sm sm:max-w-xl sm:justify-center mx-auto mb-8">
            <a
              href="https://www.micromilspec.com/collections/spaceforce"
              class="bg-black rounded-lg p-3 px-4 border border-white inline-flex justify-between items-center gap-4">
              <span>U.S. Space Force Employees</span>
              <span><svg
                class="h-4"
                width="16"
                height="27"
                viewBox="0 0 16 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 2L13.5 13.5L2 25"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round" />
              </svg>
              </span>
            </a>
            <a
              href="https://www.micromilspec.com/collections/spaceforce-watch"
              class="bg-black rounded-lg p-3 px-4 border border-white inline-flex justify-between items-center gap-4">
              <span>U.S. Citizens</span>
              <span><svg
                class="h-4"
                width="16"
                height="27"
                viewBox="0 0 16 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 2L13.5 13.5L2 25"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round" />
              </svg>
              </span>
            </a>
          </div>
          <p class="my-6 text-center max-w-lg block mx-auto">
            Designed in collaboration with esteemed members of the <nobr>U.S. Space Force</nobr>. Exclusively available on a made-to-order basis.
          </p>
          <div
            v-if="data.show_countdown"
            class="mb-8 text-center">
            <div class="text-sm md:text-base uppercase block mb-2">
              Sale ends in:
            </div>
            <countdown
              :date="data.countdown_date"
              class="text-xs" />
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "@/Shared/Layout.vue"
import ResponsiveImage from "@/Pages/Sales/Fragments/ResponsiveImage.vue"
import Countdown from "@/Pages/Sales/Fragments/Countdown.vue"

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  components: {
    Layout,
    ResponsiveImage,
    Countdown
  },

  created () {
    try {
      window.fathom("trackPageview")
    } catch (e) {}
  }
}
</script>


<style>
  .spaceforce-hero img {
    margin: 0 auto;
  }
</style>
